// extracted by mini-css-extract-plugin
export default {"card":"lua-z"};